<template>
  <div class="navigation">
    <div class="page-title">
      <el-breadcrumb separator=">"
                     class="pr30 pt15 r">
        <el-breadcrumb-item :to="{ path }">网站管理({{type}})</el-breadcrumb-item>
        <el-breadcrumb-item>{{ webSiteName }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ navName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    console.log(this.$store.state.is_overSea);
  },
  data() {
    return {
    };
  },
  computed: {
    navName() {
      return this.$store.state.navName;
    },
    webSiteName() {
      return this.$store.state.webSiteName;
    },
    type() {
      return this.$store.state.is_overSea ? '海外' : '国内';
    },
    path() {
      return this.$store.state.is_overSea ? '/website/oversae' : '/website/home';
    },
  },
};
</script>
<style lang="less">
.wq-breadcrumb {
  right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/websiteConfig/navigation.vue